import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from 'src/app/shared/shared.module';
import { NgxPaginationModule } from 'ngx-pagination';

import { AffiliateComponent } from './affiliate.component';
import { AffiliateService } from './affiliate.service';

import { routing } from './affiliate.routing';
import { CreateLinkComponent } from './create-link/create-link.component';
import { LinkControlComponent } from './link-control/link-control.component';
import { CampaignSettingComponent } from './campaign-setting/campaign-setting.component';
import { SymbolListComponent } from './symbol-list/symbol-list.component';
import { ManageSettingComponent } from './manage-setting/manage-setting.component';
import { UserComponent } from './link-control/user/user.component';
import { IbComponent } from './link-control/ib/ib.component';
import { IbLevelComponent } from './manage-setting/ib-level/ib-level.component';
import { DirectUserComponent } from './manage-setting/direct-user/direct-user.component';
import { NgxMaskModule   } from 'ngx-mask-2';
import { TooltipModule } from 'primeng/tooltip';
import { CreateAccountComponent } from './create-account/create-account.component';
import { RankingComponent } from './ranking/ranking.component';
import { TradingVolumeListComponent } from './trading-volume/trading-volume.component';

@NgModule({
  declarations: [
    AffiliateComponent,
    CreateLinkComponent,
    LinkControlComponent,
    CampaignSettingComponent,
    SymbolListComponent,
    ManageSettingComponent,
    UserComponent,
    IbComponent,
    IbLevelComponent,
    DirectUserComponent,
    CreateAccountComponent,
    RankingComponent,
    TradingVolumeListComponent,
  ],
  imports: [
    TooltipModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    NgxPaginationModule,
    routing,
    NgxMaskModule.forRoot()
  ],
  providers: [AffiliateService],
})
export class AffiliateModule {}
